// src/components/results/RetryDueCard.jsx
//
// Dashboard card shown while a "Retry my mistakes" set is due. Opens the retry page
// (which shows free users the set locked, with the upsell).
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate';
import { listOpenRetrySets } from '../../services/retryService';
import { getExamSlug } from '../../utils/examSlug';
import { useCaveat } from '../mockExam/RedPenCards';

export default function RetryDueCard({ uid }) {
  const { t } = useTranslation();
  useCaveat();
  const navigate = useLocalizedNavigate();
  const [set, setSet] = useState(null);
  useEffect(() => {
    let cancelled = false;
    listOpenRetrySets(uid)
      .then((sets) => { if (!cancelled) setSet(sets.find((s) => s.dueNow > 0) || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [uid]);
  if (!set) return null;
  return (
    <button type="button" onClick={() => navigate(`/exams/${getExamSlug(set.provider, set.level)}/retry/${set.id}`)}
      className="rs-lift rs-paper rs-focus w-full mb-6 text-left flex flex-wrap items-center justify-between gap-4 px-5 sm:px-6 pt-5 pb-5 touch-manipulation"
      style={{ borderTop: '6px solid #DC2626', backgroundPosition: '0 16px' }}>
      <span className="flex flex-col gap-1">
        <span className="text-[26px] leading-none text-red-600" style={{ fontFamily: "'Caveat', cursive" }}>{t('examResults.story.retry.kickerReady')}</span>
        <span className="text-lg font-bold text-stone-900" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {t('examResults.story.retry.dashTitle', { count: set.dueNow, exam: `${set.provider.toUpperCase()} ${set.level.toUpperCase()}` })}
        </span>
        <span className="text-sm text-stone-600">{t('examResults.story.retry.why')}</span>
      </span>
      <span className="shrink-0 inline-flex items-center min-h-[48px] px-5 rounded-xl bg-stone-900 text-white font-bold">{t('examResults.story.retry.start', { count: set.dueNow })} →</span>
    </button>
  );
}
